<template>
  <div class="mb-2">
    <div class="row align-items-start">
      <div class="col font-weight-bold">
        <h2 class="mb-0">{{ record.label || untitledRecord }}</h2>
      </div>
    </div>
    <div v-if="record.description" class="row">
      <div class="col">
        <span class="text-muted">
          {{ record.description }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "HeaderRecordTitleHint",
  props: {
    record: {
      type: Object,
      required: true,
    },
    showUntitledLabel: {
      type: Boolean,
      default: true,
    },
    untitledRecord: {
      type: String,
      default: "",
    }
  },
  components: {
  },
  computed: {
  },
  methods: {
  },
};
</script>
